<template>
  <div :class="$style.container">
    <mute-toggle-button v-if="canWhisper" />
    <leave-button />
  </div>
</template>

<script>
  import store from '@/lib/store'
  import MuteToggleButton from './mute-toggle-button/mute-toggle-button'
  import LeaveButton from './leave-button/leave-button'

  export default {
    components: {
      MuteToggleButton,
      LeaveButton
    },
    data () {
      return {
        team: store.get('team')
      }
    },
    computed: {
      canWhisper () {
        return this.team.features.some(feature => feature.name === 'DIALER_LIVE_COACH_WHISPERING')
      }
    }
  }
</script>

<style module lang="less" src="./toolbar.less"></style>



// WEBPACK FOOTER //
// toolbar.vue?56a3bc78